/** Modos de pagamento dos pedidos */
export enum ConfigPedidoModoPagamento {
  MANUAL = 1,
  CONDICAO_PAGAMENTO = 2
}

/** Valor de um modo de pagamento dos pedidos*/
export interface ConfigPedidoModoPagamentoValue {
  id: ConfigPedidoModoPagamento;
  nome: string;
}

/** Manual */
export const CONFIG_PEDIDO_MODO_PAGAMENTO_MANUAL: ConfigPedidoModoPagamentoValue = {
  id: ConfigPedidoModoPagamento.MANUAL,
  nome: 'Manual'
};

/** Condição de Pagamento */
export const CONFIG_PEDIDO_MODO_PAGAMENTO_CONDICAO_PAGAMENTO: ConfigPedidoModoPagamentoValue = {
  id: ConfigPedidoModoPagamento.CONDICAO_PAGAMENTO,
  nome: 'Condição de Pagamento'
};

/** Modos de pagamento dos pedidos */
export const CONFIG_PEDIDO_MODOS_PAGAMENTO: ConfigPedidoModoPagamentoValue[] = [
  CONFIG_PEDIDO_MODO_PAGAMENTO_MANUAL,
  CONFIG_PEDIDO_MODO_PAGAMENTO_CONDICAO_PAGAMENTO
];

/** Verifica se o modo de pagamento é manual */
export function isConfigPedidoModoPagamentoManual(modoPagamento: number): boolean {
  return modoPagamento === CONFIG_PEDIDO_MODO_PAGAMENTO_MANUAL.id;
}

/** Verifica se o modo de pagamento é condição de pagamento */
export function isConfigPedidoModoPagamentoCondicaoPagamento(modoPagamento: number): boolean {
  return modoPagamento === CONFIG_PEDIDO_MODO_PAGAMENTO_CONDICAO_PAGAMENTO.id;
}
